import React from 'react';
import { useParams } from 'react-router-dom';
import { ProfessionaleSanitaFormFlowStyles } from './styles/ProfessionaleSanitaFormFlow.styles';
import ProfessioniSanitarie from './components/ProfessioniSanitarie';
import MediciLiberiProfessionisti from './components/MediciLiberiProfessionisti';
import MediciDipendenti from './components/MediciDipendenti';
import MedicoProtetto from './components/MedicoProtetto';

function ProfessionaleSanitaFormFlow() {
  const { sub_product } = useParams();
  return (
    <>
      <ProfessionaleSanitaFormFlowStyles>
        {sub_product === 'professioni-sanitarie'
          && (
            <ProfessioniSanitarie selectedSubProduct="professioni_sanitarie" />
          )}
        {sub_product === 'medici-liberi-professionisti'
          && (
            <MediciLiberiProfessionisti selectedSubProduct="medici_liberi_professionisti" />
          )}
        {sub_product === 'medici-dipendenti'
          && (
            <MediciDipendenti selectedSubProduct="medici_dipendenti" />
          )}
        {sub_product === 'medico-protetto'
          && (
            <MedicoProtetto selectedSubProduct="medico_protetto" />
          )}

      </ProfessionaleSanitaFormFlowStyles>

    </>
  );
}

export default ProfessionaleSanitaFormFlow;
